module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      bg: _vm.bg
    }
  }, [_c('v-container', {
    staticClass: "inner-container",
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    class: [("order-md-" + _vm.order1), 'order-1'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order1
    }
  }, [_c('div', {
    staticClass: "text-container d-block justify-center align-center align-md-start flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.title2) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "ul-list"
  }, _vm._l((_vm.list1), function(list, i) {
    return _c('li', {
      key: i
    }, [_vm._v("\n              " + _vm._s(list) + "\n            ")])
  }))])]), _vm._v(" "), _c('v-flex', {
    class: [("order-md-" + _vm.order2), 'order-2'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order2
    }
  }, [_c('div', {
    staticClass: "img-container d-flex justify-center align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "_pad-first-flex": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    class: [("order-md-" + _vm.order3), 'order-1'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order1
    }
  }, [_c('div', {
    staticClass: "text-container pl-md-15 d-block justify-center align-center align-md-start flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v("\n            " + _vm._s(_vm.title3) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.title4) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "ul-list"
  }, _vm._l((_vm.list2), function(list, k) {
    return _c('li', {
      key: k
    }, [_vm._v("\n              " + _vm._s(list) + "\n            ")])
  }))])]), _vm._v(" "), _c('v-flex', {
    class: [("order-md-" + _vm.order4), 'order-2'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order2
    }
  }, [_c('div', {
    staticClass: "img-container pr-md-10 d-flex justify-center align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc1
    }
  })])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0c89a5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing2/CommonSection.vue
// module id = 1606
// module chunks = 180